
import { faArrowAltCircleUp } from "@fortawesome/free-regular-svg-icons/faArrowAltCircleUp";
import { faSquareCheck } from "@fortawesome/free-regular-svg-icons/faSquareCheck";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faClipboard } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import React, { memo, useContext, useState } from "react";
import { PaginaPesquisaProdutoContext } from "../../pagina-pesquisa-produto/PaginaPesquisaProduto";
import { ProdutosSelecionadosContext } from "../../PaginaPesquisaProdutoContainer";
const estilosBarraFerramentasGrid =
  require("./barra-ferramentas-grid.module.scss").default;
const estilosBotoes = require("../../../../estilos/botoes.module.scss").default;

export type BarraFerramentasGridPesquisaProdutosProps = {
  sufixoId?: string
};

export const BarraFerramentasGridPesquisaProdutos = memo((props: BarraFerramentasGridPesquisaProdutosProps) => {
  //491123 const [expandirDropDown, setExpandirDropDown] = useState(false);
  const sufixoId = props.sufixoId ?? ""
  const contexto = useContext(PaginaPesquisaProdutoContext)
  const {
    desativarBotaoSelecionar,
    quantidadeItensSelecionados,
    onSelecionar,
  } = useContext(ProdutosSelecionadosContext);

  return (
    <div
      className={`_flex _flex-row _w-full ${estilosBarraFerramentasGrid.barraFerramentasGrid}`}
      id={`BarraFerramentasGridPesquisaProdutos_div${sufixoId}`}
      style={{ marginBottom: "10px" }}
    >

      {contexto.pesquisandoApenasParaFiltroProdutosLupa &&
        <button
          className={estilosBarraFerramentasGrid.backgroundButton}
          onClick={() => contexto.onOk()}
          id={`BarraFerramentasGridPesquisaProdutos_botaoOk${sufixoId}`}
          disabled={contexto.processandoProduto}
        >
          Ok
        </button>
      }
      {/* -- 491123 --> contexto.chamadoParaInserirProdutoNoOrcamento &&
          <button
            className={estilosBarraFerramentasGrid.backgroundButton}
            onClick={() => contexto.onInserirContinuar()}
            id={`BarraFerramentasGridPesquisaProdutos_botaoInserirEContinuar${sufixoId}`}
            title="Insere produtos selecionados no orçamento e continua na pesquisa de produtos - Tecla Atalho [9]"
            disabled={contexto.processandoProduto}
            accessKey="9"
          >
            Inserir e Continuar
          </button>
          */}


      <button
        className={`${estilosBotoes.botaoIcone} no-global-button`}
        onClick={() => contexto.onSelecionarTodos()}
        id={`BarraFerramentasGridPesquisaProdutos_botaoSelecionarTodos${sufixoId}`}
        title="Selecionar todos"
        disabled={contexto.processandoProduto}
      >
        <FontAwesomeIcon icon={faSquareCheck} />
        <span className={estilosBarraFerramentasGrid.textoBotao}>Selecionar todos</span>
      </button>

      {/*-- 491123 -->  contexto.habiliarAcoesGrid && !contexto.ocultarSubPaginas && !contexto.pesquisandoApenasParaFiltroProdutosLupa && (

        <div className="_relative">
          <button
            className={`${estilosBotoes.botaoIcone} no-global-button`}
            disabled={contexto.desativarBotaoAcoes || contexto.processandoProduto}
            onClick={() => setExpandirDropDown(!expandirDropDown)}
            id={`BarraFerramentasGridPesquisaProdutos_botaoAcoes${sufixoId}`}
            title="Ações"
          >
            <FontAwesomeIcon icon={faClipboard} />
            <span className={estilosBarraFerramentasGrid.textoBotao}>Ações</span>
          </button>
          {expandirDropDown && (
            <ul
              className="_absolute _-bottom-30 _left-0 _bg-white"
              onMouseLeave={() => setExpandirDropDown(false)}
            >
              <li
                className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                onClick={() => { contexto.onInserirNovo(); setExpandirDropDown(false) }}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={faCirclePlus}
                  color="#409fff"
                  title="Inserir Novo"
                />
                <span className={estilosBarraFerramentasGrid.textoBotao}>Inserir Novo</span>
              </li>
              <li
                className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                onClick={() => { contexto.onIncrementarQuantidade(); setExpandirDropDown(false) }}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={faArrowAltCircleUp}
                  color="#409fff"
                  title="Incrementar Quantidade"
                />
                <span className={estilosBarraFerramentasGrid.textoBotao}>Incrementar Quantidade</span>
              </li>
            </ul>
          )}
        </div>
      )
        */}

      {!contexto.ocultarSubPaginas &&  // 440721
        <button
          onClick={() => contexto.onComparar()}
          id={`BarraFerramentasGridPesquisaProdutos_botaoComparar${sufixoId}`}
          title="Comparar"
          className={`${estilosBotoes.botaoIcone} ${estilosBarraFerramentasGrid.botaoComparar} no-global-button`}
          disabled={contexto.desativarBotaoComparar || contexto.processandoProduto}
        >
          <span className={estilosBarraFerramentasGrid.textoBotao}>Comparar</span>
        </button>
      }

      {/* Último botão da barra: texto reflete a quantidade de itens selecionados.
          491123 — _ml-auto empurra o botão para o canto direito; sem no-global-button/botaoIcone
          para usar o mesmo estilo global azul do PaginaPesquisaProduto_botaoPesquisar */}
      {contexto.chamadoParaInserirProdutoNoOrcamento &&
        <button
          className="_ml-auto"
          onClick={() => onSelecionar()}
          id={`BarraFerramentasGridPesquisaProdutos_botaoSelecionar${sufixoId}`}
          disabled={contexto.processandoProduto || desativarBotaoSelecionar}
          title="Adiciona os produtos selecionados na cesta de produtos"
        >
          <i
            className="material-symbols-rounded"
            style={{ verticalAlign: "middle", marginRight: "4px", fontSize: "18px", color: "inherit" }}
          >local_mall</i>
          <span className={estilosBarraFerramentasGrid.textoBotao}>
            {quantidadeItensSelecionados === 0
              ? "Adicionar"
              : `Adicionar ${quantidadeItensSelecionados} ${quantidadeItensSelecionados === 1 ? "Item" : "Itens"}`}
          </span>
        </button>
      }

    </div>
  );
})
